export default function convertDurationToMinutes(duration: string): number {
    const [minutes, seconds] = duration.split(':').map(Number); // Split the duration by ":" and convert each part to a number
    return minutes + (seconds / 60); // Calculate total minutes
  }